import * as z from "zod";

import { PartnerUserSummarySchema } from "../shared/partner-user";

export const verifyMagicLink = {
  name: "verifyMagicLink" as const,
  input: z.object({ token: z.string().min(1).max(4096) }),
  output: z.object({
    partnerUser: PartnerUserSummarySchema,
    authToken: z.string().min(1),
  }),
};
